<app-dialog-header title="Edit Planner Note - {{ data.ticketReference }}" (closeClicked)="onCancel()">
</app-dialog-header>

<mat-dialog-content>
  <p>This note will be available to the operative for this ticket on despatch. Changes to the note
    content
  after despatch will not be visible to the operative.</p>
  <form [formGroup]="plannerNoteForm">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Planner Note</mat-label>
      <textarea #autosize="cdkTextareaAutosize" cdkAutosizeMaxRows="10" cdkAutosizeMinRows="3" cdkTextareaAutosize
        formControlName="noteContent" matInput placeholder="Enter planner note for this ticket..."
      aria-label="Planner note content"></textarea>
      @if (noteContent?.hasError('required')) {
        <mat-error>
          Planner note is required
        </mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="plannerNoteForm.invalid">
    Save Note
  </button>
</mat-dialog-actions>
